import VimeoPlayer from '@vimeo/player';
import { useEffect, useState } from 'react';
import Loader from '../../Tools/Loader';

export default function Vimeo({id}){

    const [ready, setReady] = useState(false)

    useEffect(() => {

        const t = setTimeout(() => setReady(true), 300)

        setReady(false);

        return () => clearTimeout(t)

    }, [id])


    const handleLoad = () => {

        const player = new VimeoPlayer(id);

        player.on('ended', function() {
            document.getElementById('next-button').click();
        });
        
        return player;
    }

    return !ready ? <Loader /> :
    
    <iframe
        id={id}
        title='Vimeo Player'
        src={"https://player.vimeo.com/video/" + id + "?autoplay=1"} 
        width="100%"
        height="99%" 
        frameBorder="0"
        allow="autoplay; fullscreen"
        onLoad={handleLoad}
    >
    </iframe>
}
